module.exports = __webpack_public_path__ + "img/text.b3d15a90.svg";